import type { JSX } from "react";

import { Button, Flex, Text } from "@mantine/core";

import { withPolymorphicClickAnalytics } from "@/analytics";

import { useControlsStore } from "../controls.store";
import styles from "./Dialpad.module.css";

interface DialButtonProps {
    subtitle: string;
    title: string;
}

function titleToSafeAnalyticTitle(title: string): string {
    if (title === "#") {
        return "pound";
    }

    if (title === "*") {
        return "star";
    }

    return title;
}

export function DialButton({ subtitle, title }: DialButtonProps): JSX.Element {
    const dialpadInput = useControlsStore((state) => state.dialpadInput);
    const isMuted = useControlsStore((state) => state.isMuted);

    const handleClick = (input: string) => {
        useControlsStore.getState().setDialpadInput(dialpadInput + input);
    };

    const DialpadOptionButton = withPolymorphicClickAnalytics(Button<"button">, "Click");
    const safeAnalyticsTitle = titleToSafeAnalyticTitle(title);

    return (
        <DialpadOptionButton
            analytics={{
                actionId: `DialOptionButton-${safeAnalyticsTitle}`,
            }}
            classNames={{ label: styles.buttonLabel }}
            color="gray.3"
            bg={isMuted ? "var(--exwo-color-control-bar-bg)" : undefined}
            data-testid="call-controls-dial-option-input"
            disabled={isMuted}
            mih="3.25rem"
            onClick={() => {
                handleClick(title);
            }}
            p="0rem"
            radius="md"
            variant="subtle"
        >
            <Flex direction="column">
                <Text c="gray.3" fw={700}>
                    {title}
                </Text>
                <Text c="gray.5" fw={400} size="xs">
                    {subtitle}
                </Text>
            </Flex>
        </DialpadOptionButton>
    );
}
